import parse from "date-fns/parse";
import format from "date-fns/format";

export const API_DATE_FORMAT = "yyyy-MM-dd";

export function convertAPIDateResponse(date?: string) {
  if (!date) return undefined;
  return parse(date, API_DATE_FORMAT, new Date());
}

export function convertToAPIDate(date?: Date) {
  if (!date) return "";
  return format(date, API_DATE_FORMAT);
}
